// extracted by mini-css-extract-plugin
export default {"divAbsolute":"style_divAbsolute__YfNd7","divSpinner":"style_divSpinner__P-Hn6","spinner":"style_spinner__p5Pd8","spinnerText":"style_spinnerText__znwcg"};